import DataTable from '@medeloop/medeloop-components-library/dist/components/DataTable';
import { useTranslation } from 'react-i18next';
import { Organization } from 'src/types/organizations';

export function OrganizationalUnitsTable({ organizations }: { organizations: Organization[] }) {
  const { t } = useTranslation();

  return (
    <DataTable className="px-6 py-4">
      <DataTable.Header>
        <DataTable.HeaderCell>{t('name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('researchers_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('studies_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('data_sources_header')}</DataTable.HeaderCell>
      </DataTable.Header>

      <DataTable.Body className="h-96 overflow-auto">
        {organizations.length > 0 ? (
          organizations.map((organization: Organization) => (
            <DataTable.Row key={organization.organizationId}>
              <DataTable.RowCell>{organization.displayName}</DataTable.RowCell>
              <DataTable.RowCell>{organization.numResearchers}</DataTable.RowCell>
              <DataTable.RowCell>{organization.numStudies}</DataTable.RowCell>
              <DataTable.RowCell>{organization.numDataSources}</DataTable.RowCell>
            </DataTable.Row>
          ))
        ) : (
          <div className="flex flex-grow text-white items-center justify-center p-4">
            {t('no_organizational_units_created')}
          </div>
        )}
      </DataTable.Body>
    </DataTable>
  );
}
